import { CSSProperties } from "react";

export const XDiscardSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  const ratio = 85 / 57;
  const height = ratio * width;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 57 85"
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_503_2)">
        <rect
          x="1"
          y="1"
          width="55"
          height="83"
          rx="1"
          fill="url(#paint0_linear_503_2)"
        />
        <rect
          x="1.5"
          y="1.5"
          width="54"
          height="82"
          rx="0.5"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <path
        d="M19.3539 44.1694H19.8539V43.6694V20.5L37.1463 20.5001V43.6697V44.1697H37.6463H43.0186L28.5001 64.1494L13.9814 44.1694H19.3539Z"
        fill="white"
        stroke="black"
      />
      <defs>
        <filter
          id="filter0_di_503_2"
          x="0"
          y="0"
          width="57"
          height="85"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_503_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_503_2"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_503_2"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_503_2"
          />
        </filter>
        <linearGradient
          id="paint0_linear_503_2"
          x1="28.5"
          y1="1"
          x2="28.5"
          y2="84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D38818" />
          <stop offset="0.0833333" stopColor="#DE9C39" />
          <stop offset="0.197917" stopColor="#C28529" />
          <stop offset="0.557292" stopColor="#8B5709" />
          <stop offset="0.817708" stopColor="#C28529" />
          <stop offset="0.9375" stopColor="#DE9C39" />
          <stop offset="1" stopColor="#EDA73E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
